





































import { Component, Vue } from "vue-property-decorator";
import VListGroup from "@/components/VListGroup.vue";

@Component({
  components: {
    VListGroup,
  },
})
export default class Lists extends Vue {
  items = [
    {
      id: 1,
      text: "Item 1",
    },
    {
      id: 2,
      text: "Item 2",
    },
    {
      id: 3,
      text: "Item 3",
    },
    {
      id: 4,
      text: "Item 4",
    },
    {
      id: 5,
      text: "Item 5",
    },
  ];
}
